﻿export class RioFileExtensionApiModel {
    extension: string;
    description: string;
    validImage: boolean;
    resourceID: number;
    resourceName: string;
}